import { render, staticRenderFns } from "./DiaMesMaisFrequenteCard.vue?vue&type=template&id=06d11120"
import script from "./DiaMesMaisFrequenteCard.vue?vue&type=script&lang=js"
export * from "./DiaMesMaisFrequenteCard.vue?vue&type=script&lang=js"
import style0 from "./DiaMesMaisFrequenteCard.vue?vue&type=style&index=0&id=06d11120&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports